module.exports = __webpack_public_path__ + "static/media/history-drake.20f7298d.vtt";